import { render, staticRenderFns } from "./EventsAttrs.vue?vue&type=template&id=2f124838&scoped=true&"
import script from "./EventsAttrs.vue?vue&type=script&lang=js&"
export * from "./EventsAttrs.vue?vue&type=script&lang=js&"
import style0 from "./EventsAttrs.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EventsAttrs.vue?vue&type=style&index=1&id=2f124838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f124838",
  null
  
)

export default component.exports